import React from 'react'

import { FilePreview } from './FilePreview'
import { UrlPreview } from './UrlPreview'

interface GenericPreviewProps {
  file?: File
  url?: string
}

export const GenericPreview = (props: GenericPreviewProps) => {
  const { file, url } = props

  if (file) {
    return <FilePreview file={file} />
  } else if (url) {
    return <UrlPreview url={url} />
  }
  return null
}
